<script setup>
import { useField } from 'vee-validate'
const props = defineProps(['field', 'modelValue'])

const { value: model } = useField(
  () => props.field.clean_name,
  { required: props.field.required },
  {
    syncVModel: true,
  }
)

const options = props.field.choices?.length
  ? props.field.choices?.split('\r\n')
  : []
</script>

<template>
  <div class="box is-checklist">
    <template v-if="options.length">
      <b-checkbox
        v-for="item in options"
        v-model="model"
        :nativeValue="item"
        :name="field.clean_name"
      >
        {{ item }}
      </b-checkbox>
    </template>

    <b-checkbox
      v-model="model"
      :nativeValue="true"
      :name="field.clean_name"
      v-else
    >
      {{ field.label }}
    </b-checkbox>
  </div>
</template>
